"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsCreateProductionOrderStationButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _DmsFetch = require("../../DmsFetch/DmsFetch");
var _DmsTokenHook = require("../../DmsTokenHook/DmsTokenHook");
var _HttpStatus = require("../../../constants/HttpStatus");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _DmsButton = require("../../DmsButton/DmsButton");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsCreateProductionOrderStationButton component
 * @param {object} row_data - data of row in DmsTable
 * 
 * example:
 *  <DmsCreateProductionOrderStationButton
                    row_data={row_data}
                    />
 */

const DmsCreateProductionOrderStationButton = _ref => {
  let {
    row_data,
    table
  } = _ref;
  const [open, setOpen] = (0, _react.useState)(false);
  const [stationOptions, setStationOptions] = (0, _react.useState)([]);
  const [stationPk, setStationPk] = (0, _react.useState)("");
  const [quantity, setQuantity] = (0, _react.useState)(0);
  const token = (0, _DmsTokenHook.getToken)();
  (0, _react.useEffect)(() => {
    const fetchStationOptions = async () => {
      try {
        const result = await (0, _DmsFetch.fetchData)("/station/all", "GET", token);
        if (result.status === _HttpStatus.HTTP_STATUS.OK_200) {
          const options = result.data.data.map(station => ({
            value: station.pk,
            label: station.name
          }));
          setStationOptions(options);
        } else {
          _sweetalert.default.fire({
            title: _reactIntlUniversal.default.get("Error").d("Error"),
            text: _reactIntlUniversal.default.get("FailedFetchStationOption").d("Failed to fetch station options."),
            icon: "error",
            confirmButtonText: _reactIntlUniversal.default.get("OK").d("OK")
          });
        }
      } catch (error) {
        _sweetalert.default.fire({
          title: _reactIntlUniversal.default.get("Error").d("Error"),
          text: _reactIntlUniversal.default.get("UnexpectedError").d("An unexpected error occurred."),
          icon: "error",
          confirmButtonText: _reactIntlUniversal.default.get("OK").d("OK")
        });
      }
    };
    fetchStationOptions();
  }, [open]);
  const handleSubmit = async e => {
    e.preventDefault();
    const payload = {
      production_order_pk: row_data.pk,
      station_pk: stationPk,
      quantity: parseInt(quantity, 10)
    };
    setOpen(false);
    const url = "/production_order_station";
    const postProductionOrderStation = await (0, _DmsFetch.fetchData)(url, "POST", token.access_token, payload);
    if (postProductionOrderStation.status !== _HttpStatus.HTTP_STATUS.CREATED_201) {
      _sweetalert.default.fire({
        title: _reactIntlUniversal.default.get("Error").d("Error"),
        text: _reactIntlUniversal.default.get("FailedCreateProductionOrderStation").d("Failed to create production order station."),
        icon: "error",
        confirmButtonText: _reactIntlUniversal.default.get("OK").d("OK")
      });
    }
    if (table && table.current) {
      table.current.updateTable();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "primary",
    icon: /*#__PURE__*/_react.default.createElement(_Add.default, null),
    onClick: () => setOpen(true)
  }), /*#__PURE__*/_react.default.createElement(_material.Dialog, {
    open: open,
    onClose: () => setOpen(false),
    fullWidth: true,
    maxWidth: "sm"
  }, /*#__PURE__*/_react.default.createElement(_material.DialogTitle, null, _reactIntlUniversal.default.get("CreateProductionOrderStationRelation").d("Create production order station relation")), /*#__PURE__*/_react.default.createElement(_material.DialogContent, {
    dividers: true
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "form",
    onSubmit: handleSubmit,
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    margin: "normal",
    label: _reactIntlUniversal.default.get("ProductionOrder").d("Production order"),
    value: row_data.order_number,
    InputProps: {
      readOnly: true
    }
  }), /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    margin: "normal",
    select: true,
    label: _reactIntlUniversal.default.get("Station").d("Station"),
    value: stationPk,
    onChange: e => setStationPk(e.target.value),
    placeholder: _reactIntlUniversal.default.get("SelectAStation").d("Select a station"),
    required: true
  }, stationOptions.map(option => /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    key: option.value,
    value: option.value
  }, option.label))))), /*#__PURE__*/_react.default.createElement(_material.DialogActions, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    onClick: () => setOpen(false),
    variant: "secondary"
  }, _reactIntlUniversal.default.get("Close").d("Close")), /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    type: "submit",
    variant: "contained",
    color: "primary",
    onClick: handleSubmit
  }, _reactIntlUniversal.default.get("Create").d("Create")))));
};
exports.DmsCreateProductionOrderStationButton = DmsCreateProductionOrderStationButton;